import { ProfileState } from './types'

export const initialProfileState: ProfileState = {
	authenticated: false,
	accessToken: '',
	userId: '',
	email: '',
	role: 4,
	loggedIn: false,
	gravatarUrl: '',
	location: window.location.pathname,
	accessType: 'prod',
	displayName: 'Not Logged In',
	showLoginModal: false,
	stickyLoginModal: false,
	lang: null
}
